.parallaxWrapper {
	background-size: cover;
	display: block;
	position: relative;
	overflow: hidden;
	-webkit-perspective: 10000px;
	perspective: 10000px;
	align-items: center;
	justify-content: center;
	width: 100%;
	.parallaxBackgrounds {
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;
		right: 0;
		-webkit-transform-style: preserve-3d;
		transform-style: preserve-3d;
		-webkit-transform: translateZ(0);
		-ms-transform: translateZ(0);
		transform: translateZ(0);
		img {
			display: block;
			width: 100%;
			max-width: 100%;
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			background-color: rgba(255, 255, 255, 0.01);
			&:not(:first-child) {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
			}
		}
	}
}
